import type { FC } from 'react';

import Ellipsis from '../../ellipsis/ellipsis';

import styles from './transcoder_name.module.css';

type Props = { transcoderName: string };

export const TranscoderName: FC<Props> = ({ transcoderName }) => {
  return (
    <Ellipsis
      componentProps={{ className: styles.root }}
      tooltipText={transcoderName}
    >
      {transcoderName}
    </Ellipsis>
  );
};
